import { FilterGroup } from '@vendasta/va-filter2';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CurrentlyWaitingFiltersService {
  filters: FilterGroup = new FilterGroup('currentlyWaiting');
}
